function getMarkerData(container) {
	return Array.from(container.querySelectorAll('[data-lat][data-lng]'))
		.map((item) => ({
			lat: parseFloat(item.dataset.lat),
			lng: parseFloat(item.dataset.lng),
			heading: item.dataset.heading || '',
			address: item.dataset.address || '',
		}))
		.filter((location) => !isNaN(location.lat) && !isNaN(location.lng))
}

function getPopupContent(heading, address) {
	if (address) {
		return `<div class="maps-popup small" style="max-width:240px;"><h6 class="fw600" style="color: var(--dark);margin-bottom:5px;">${heading}</h6><p style="font-family: var(--font-family-pri); font-size: var(--font-size); line-height: var(--lh); font-weight: var(--font-weight-light); color: var(--dark);">${address}</p></div>`
	}

	return `<div class="maps-popup small" style="max-width:240px;"><h6 class="fw600" style="color: var(--dark);margin-bottom:5px;">${heading}</h6></div>`
}

function initPropertiesMap(mapElement) {
	const listingTarget = document.getElementById(mapElement.dataset.listingTarget || 'listing')

	if (!listingTarget) return

	const infoWindow = new google.maps.InfoWindow()
	const map = new google.maps.Map(mapElement, {
		zoom: parseInt(mapElement.dataset.zoom, 10) || 12,
		...(mapElement.dataset.mapId ? { mapId: mapElement.dataset.mapId } : {}),
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: true,
	})

	let markers = []

	function setMarkers(locations) {
		markers.forEach((marker) => marker.setMap(null))
		markers = []
		infoWindow.close()

		if (!locations.length) return

		const bounds = new google.maps.LatLngBounds()

		locations.forEach(({ lat, lng, heading, address }) => {
			const position = new google.maps.LatLng(lat, lng)
			const marker = new google.maps.Marker({
				position,
				map,
				title: heading,
				icon: {
					url: '/assets/svg/marker.svg',
					scaledSize: new google.maps.Size(40, 40),
					origin: new google.maps.Point(0, 0),
				},
			})

			marker.addListener('click', () => {
				infoWindow.setContent(getPopupContent(heading, address))
				infoWindow.open(map, marker)
			})

			bounds.extend(position)
			markers.push(marker)
		})

		map.fitBounds(bounds)
	}

	setMarkers(getMarkerData(listingTarget))

	const filterForm = document.querySelector('#listing__filter form')

	if (filterForm) {
		filterForm.addEventListener('onAsyncChange', (event) => {
			const doc = new DOMParser().parseFromString(event.detail.response.rendered, 'text/html')
			setMarkers(getMarkerData(doc))
		})
	}
}

export function propertiesMap() {
	const mapElements = document.querySelectorAll('[data-properties-map]')

	if (!mapElements.length) return

	window.googleMapScripts = window.googleMapScripts || []
	window.googleMapScripts.push(() => {
		mapElements.forEach(initPropertiesMap)
	})
}
